import { Component, NgZone, Input, OnChanges } from '@angular/core';

import { NavController,IonicPage, ModalController, NavParams} from 'ionic-angular';

import { UserData } from '../../providers/user-data';
import { ToastController } from 'ionic-angular';

import moment from 'moment';
import { Http } from '@angular/http';

import { CommonData } from '../../providers/common-data';
import { KontrolleData } from '../../providers/kontrolle-data';

import { UEModel } from '../ue/ue-model';
import { AlertController } from 'ionic-angular';
import { UEData } from '../../providers/ue-data';
import { OpenALPR, OpenALPROptions, OpenALPRResult } from '@ionic-native/openalpr';
import { PbcheckresultComponent } from "../../components/pbcheckresult/pbcheckresult";


declare var CordovaExif : any;
//declare var cordova : any;

declare var FileTransfer : any;
declare var HTMLImageElement : any;
declare var navigator : any;
declare var device : any;

@Component({
  selector: 'ue-edit',
  templateUrl: 'ue-edit.html'
})
export class UEEditPage {
  sNormalColor = "primary";
  sCheckedColor = "secondary";

  plateLookupTimer;

  oUE;
  oUECopy;
  viewmode;
  oKontrolle;
  constructor(
              private navParams: NavParams
            , public navCtrl: NavController
            , public userData: UserData
            , public toastCtrl: ToastController
            , public zone: NgZone
            , public common: CommonData
            , public http: Http
            , public modalCtrl: ModalController
            , public ueModel: UEModel 
            , public alertCtrl: AlertController
            , public ueData: UEData
            , public kontData: KontrolleData
            , public openALPR: OpenALPR
            ) {
    //let selectedpp = navParams.get('pp');
    
    this.init();
    //this.ueModel.iGrundid = navParams.data.grundid;
    this.oUE = navParams.data;
    this.oUECopy = Object.assign({}, this.oUE);
    this.oUECopy.updatehalter = true;
    this.viewmode = "info";


  
    if(!this.userData.editmode && !userData.isAllowed('1','u')){
      this.readonly();      
    }
    else{
      if(this.oUECopy.halter1 == null || this.oUECopy.halter1 == ""){
        this.onLookupPlate(null);
      }
  
    }

    //console.log(this.oSelectedUE);

   }

   onChange($event){
     /*
     if((this.oUECopy.status.indexOf("3_")>=0 || this.oUECopy.status.indexOf("4_")>=0 || this.oUECopy.status.indexOf("6_")>=0) && ( this.oUECopy.status != "3_anzeigebereit_wart")){
            this.oUECopy.betrag = 50;
            let toast = this.toastCtrl.create({
              message: 'Betrag auf CHF 50 gesetzt',
              position: 'top',
              cssClass: 'toast-error',
              duration: 3000
            });
            toast.present();          
     }
     */
     //console.log(this.oUECopy.status);
   }

   onLookupPlate($event){
    if (this.plateLookupTimer) {
      clearTimeout(this.plateLookupTimer);
    }
    this.plateLookupTimer = setTimeout(() => {
      //console.log('do lookup');

      this.http.get(this.common.baseurl+'halters/findhalterbynummer?autonummer='+this.oUECopy.autonummer+'&token='+this.userData.jwt).subscribe(res => {
          
        let halter = res.json();
        if(halter.success){
          let alert = this.alertCtrl.create();
          alert.setTitle("Halter gefunden");
          alert.setSubTitle('Soll der Halter '+halter.data.halter1+' übernommen werden?');
    
          alert.addButton({
            text: 'JA',
            handler: (data: any) => {
              this.oUECopy.halter1 = halter.data.halter1;
              this.oUECopy.halter2 = halter.data.halter2;
              this.oUECopy.halter3 = halter.data.halter3;
              this.oUECopy.halter4 = halter.data.halter4;
            }
          });
          alert.addButton('Nein');
    
          alert.present();          

        }        

      }, error => {
        console.log('HTTP Error, no answer findhalterbynummer');
        console.log(error);
    });      

      this.plateLookupTimer = null;
    }, 2000);     
   }

   init(){
  
   }
   save(){

     Object.assign(this.oUE, this.oUECopy);
      Promise.all([
          this.ueData.update(this.oUECopy),            
        ]).then(data => {
          //console.log(data);
          this.navCtrl.pop();
          //refresh.complete();     
        });         
     


   }
   edit(){
    this.userData.editmode = this.userData.isAllowed('1','u');
    //this.editmode = 'edit';
   }
   readonly(){
    this.userData.editmode = false;
     //this.editmode = 'view';
   }   
   confirmStorno(ue){
     let title = "";
     let param: any;
      
      title = "Soll UE mit Ref.Nr.:'"+ue.busid+"' wirklich storniert werden?";
     
      let alert = this.alertCtrl.create();
      alert.setTitle(title);
      alert.setSubTitle('Grund:');
      alert.addInput({
          type: 'textarea',
          label: 'Grund',
          
      });

      alert.addButton({
        text: 'Ja, stornieren',
        handler: (data: any) => {
            if(data[0]){
              this.storno(ue, data[0]);
            }
            else{
              let alert2 = this.alertCtrl.create();
              alert2.setTitle("Grund angeben");
              alert2.setSubTitle('Bitte geben Sie einen Grund für die Stornierung an');
              alert2.addButton('Ok');
              alert2.present();
            }
            //this.testCheckboxOpen = false;
        }
      });
      alert.addButton('Abbrechen');

      alert.present();
      
   }   
   storno(ue,reason){
       
        Promise.all([
            this.ueData.sotrno(ue, reason),            
          ]).then(data => {
            //console.log(data);
            //this.einsatzplan = this.einsatzplanData.data;      
            this.navCtrl.pop();
          });   
   }   
  doRefresh(refresh){
      if(this.viewmode == "kontpictures"){
        

        Promise.all([
            this.kontData.getKontrolle(this.oUE.fkkontrolle),            
          ]).then(data => {
            //console.log(data);
            this.oKontrolle = this.kontData.data;   
            //console.log(this.oKontrolle);   
            //refresh.complete();     
          });    
        
      }
        

  }  
  
  
}



// WEBPACK FOOTER //
// ./src/pages/ue-list/ue-edit.ts